import suiteService from 'qreventos-suite/services';
import eventoService from 'qreventos-suite/eventos';

import Swal from 'sweetalert2'

class SuiteConfig {
  evento:number = 708;
  token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
  clientId: string = 'a9772d9d-d9dd-414b-b5c5-8c238d57b1d5-708';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;  

    eventoService.clientId = this.clientId;
    eventoService.token = this.token;  
  }

  async isEventoValido(redirectUrl?:string): Promise<boolean> {
    try {
      await eventoService.validarEvento(this.evento);
      return true;
    } catch (error: any) {
      await Swal.fire({ icon: "info", title: "¡Atención!", text: error?.message ?? error.toString() }).then(() => {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      });
      return false;
    }
  }  
}

export default new SuiteConfig();